import { _url } from "../configs/url";
import { customFetch } from "../configs/refreshToken";


export async function updateCompany(companyInfo) {
    let url = _url.server + _url.apiUpdateCompany;
    let dataResponse = customFetch(url, companyInfo, 'POST', '');
    return dataResponse;
}